(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3869],{

/***/ 87547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_UserOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/UserOutlined.js
// This icon file is generated automatically.
var UserOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" } }] }, "name": "user", "theme": "outlined" };
/* harmony default export */ var asn_UserOutlined = (UserOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/UserOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var UserOutlined_UserOutlined = function UserOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_UserOutlined
  }));
};
UserOutlined_UserOutlined.displayName = 'UserOutlined';
/* harmony default export */ var icons_UserOutlined = (/*#__PURE__*/react.forwardRef(UserOutlined_UserOutlined));

/***/ }),

/***/ 34140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrokerQuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87160);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var renderable = function renderable(broker) {
  var commodityTrading = broker.commodity_trading;
  var currencyTrading = broker.currency_trading;
  var accountOpeningProcess = broker.account_opening_process;
  var demat = broker.demat,
      exposure = broker.exposure; // If any of the option is availble then quickLInks are renderable
  // commodityTrading(For now only) || Otheroption || Another Option

  return commodityTrading || currencyTrading || accountOpeningProcess || demat || exposure;
};

function BrokerQuickLinks(_ref) {
  var broker = _ref.broker,
      RenderReview = _ref.RenderReview,
      currentPage = _ref.currentPage;
  if (!broker) return null;
  var name = broker.name,
      slug = broker.slug,
      commodityTrading = broker.commodity_trading,
      currencyTrading = broker.currency_trading,
      accountOpeningProcess = broker.account_opening_process,
      demat = broker.demat,
      exposure = broker.exposure;
  var title = '';
  var linkList = [];

  if (RenderReview || renderable(broker)) {
    title = 'Quick Links';

    if (RenderReview) {
      linkList.push({
        href: '/broker/[slug]/',
        as: "/broker/".concat(slug, "/"),
        linkText: " ".concat(name, " Review")
      });
    }

    if (accountOpeningProcess && currentPage !== 'AccountOpening') {
      linkList.push({
        href: '/broker/[slug]/account-opening-process',
        as: "/broker/".concat(slug, "/account-opening-process"),
        linkText: " ".concat(name, " Account Opening Process")
      });
    }

    if (commodityTrading && currentPage !== 'CommodityTrading') {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: "/broker/".concat(slug, "/commodity-trading"),
        linkText: " ".concat(name, " Commodity Trading")
      });
    }

    if (currencyTrading && currentPage !== 'currencyTrading') {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: "/broker/".concat(slug, "/currency-trading"),
        linkText: " ".concat(name, " Currency Trading")
      });
    }

    if (demat && currentPage !== 'dematAccountReviewChargesOpening') {
      linkList.push({
        href: '/broker/[slug]/demat-account-review-charges-opening',
        as: "/broker/".concat(slug, "/demat-account-review-charges-opening"),
        linkText: " ".concat(name, " Demat account review")
      });
    }

    if (exposure && currentPage !== 'margin-exposure-leverage') {
      linkList.push({
        href: '/broker/[slug]/margin-exposure-leverage',
        as: "/broker/".concat(slug, "/margin-exposure-leverage"),
        linkText: " ".concat(name, " Exposure")
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: title,
          linkList: linkList
        })
      })
    });
  }

  return null;
}
BrokerQuickLinks.defaultProps = {
  RenderReview: false,
  currentPage: 'broker'
};

/***/ }),

/***/ 3270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DetailsWithPhoto; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





function DetailsWithPhoto(_ref) {
  var details = _ref.details,
      image = _ref.image;
  if (!details) return null;
  var photo = image !== null && image !== void 0 && image.file.data[0] ? image : null;
  var description = details.split('\n');
  var lis = [];

  for (var i = 1; i < details.length; i += 1) {
    lis.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: description[i]
    }, i));
  }

  var myLoader = function myLoader(_ref2) {
    var src = _ref2.src;
    return src;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: description[0]
    }), photo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      loader: myLoader,
      src: photo.file.data[0].attributes.url,
      height: 900,
      width: 1200,
      layout: "responsive"
    }) : null, lis]
  });
}

/***/ }),

/***/ 87160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87547);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88641);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3679);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var titleFormat = function titleFormat(linkTitle, icon) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [icon, " ".concat(linkTitle)]
  });
};

function QuickLinks(props) {
  var icon = props.icon,
      title = props.title,
      linkList = props.linkList,
      country = props.country;
  if (linkList < 1 || linkList === 'undefined') return null;
  return linkList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [country === 'India' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      style: {
        paddingBottom: '32px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        style: {
          minWidth: '250px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
          target: "_blank",
          href: "https://bit.ly/2YUNebF",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            width: 252,
            height: 302,
            alt: "",
            "data-src": "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
            src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z // eslint-disable-next-line prettier/prettier
    , {
      title: titleFormat(title, icon),
      size: "small",
      bordered: false,
      style: {
        // float: 'right',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '2px',
        minWidth: '100%',
        marginBottom: '16px'
      },
      headStyle: {
        background: '#E6F7FF',
        padding: '5px 0px 0px 25px'
      },
      bodyStyle: {
        padding: '15px 20px 0px 25px',
        minWidth: '272px'
      },
      children: linkList.map(function (qlink, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          style: {
            marginBottom: '1em'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: qlink.href,
            as: qlink.as,
            children: qlink.linkText
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            style: {
              fontSize: '10px'
            },
            children: qlink.textDescription !== 'null' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
              children: qlink.textDescription
            }) : null
          })]
        }, i);
      })
    })]
  }) : null;
}
QuickLinks.defaultProps = {
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
};

/***/ }),

/***/ 20675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ FAQPageJsonLd; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22701);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var FAQPageJsonLd = function FAQPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
      articleDataArr = _ref.articleDataArr;
  var jsonld = "{\n    \"@context\": \"https://schema.org\",\n    \"@type\": \"FAQPage\",\n    \"mainEntity\": [\n      ".concat(articleDataArr.map(function (articleData) {
    return "{\n        \"@type\": \"Question\",\n        \"name\": \"".concat(articleData.attributes.title, "\" ,\n        \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": ").concat((0,_utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(articleData.attributes.short_description), "\n        }\n    }");
  }), "\n    ]\n  }");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: jsonld
    }
  }, "jsonld-article".concat(keyOverride ? "-".concat(keyOverride) : ''));
};

/***/ }),

/***/ 95501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Software; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/shared/schema/FaqSchema.tsx
var FaqSchema = __webpack_require__(20675);
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var article = __webpack_require__(28262);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./components/broker/BrokerQuickLinks.js
var BrokerQuickLinks = __webpack_require__(34140);
// EXTERNAL MODULE: ./components/shared/AddFaq.js
var AddFaq = __webpack_require__(30155);
// EXTERNAL MODULE: ./components/shared/ArticleList.tsx
var ArticleList = __webpack_require__(54242);
// EXTERNAL MODULE: ./components/shared/QuickLinks.tsx
var QuickLinks = __webpack_require__(87160);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/software/descriptionhead.tsx




function DescriptionHead(_ref) {
  var _logo$data;

  var software = _ref.software;
  var name = software.name,
      tags = software.tags,
      countries = software.countries,
      exchanges = software.exchanges,
      logo = software.logo;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      span: 24,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          md: 24,
          xs: 24,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
              span: 24,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  width: '100%'
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  height: "70px",
                  style: {
                    "float": 'left',
                    marginRight: '10px'
                  },
                  src: "".concat((_logo$data = logo.data) === null || _logo$data === void 0 ? void 0 : _logo$data.attributes.url),
                  alt: name
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  style: {
                    "float": 'left',
                    padding: '10px 10px 10px 0px'
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    style: {
                      fontSize: '18px',
                      color: '#000000'
                    },
                    children: "".concat(name, " Review")
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    style: {
                      fontSize: '15px'
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      style: {
                        color: '#000000'
                      },
                      children: "Segments: "
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: tags && tags.length > 0 ? tags.map(function (tag, i) {
                        return i === 0 ? "".concat(tag) : "/".concat(tag);
                      }) : 'No Segment Associated'
                    })]
                  })]
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
        style: {
          marginTop: '24px'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
          md: 18,
          xs: 24,
          style: {
            minHeight: '20px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: {
              color: '#000000'
            },
            children: "Countries: "
          }), countries.data && countries.data.length > 0 ? countries.data.map(function (countryObject, i) {
            return i === 0 ? "".concat(countryObject.attributes.name) : ", ".concat(countryObject.attributes.name);
          }) : 'No Country Associated']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          md: 6,
          xs: 24,
          style: {
            minHeight: '20px'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
              md: 24,
              xs: 24,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                style: {
                  color: '#000000'
                },
                children: "Exchanges: "
              }), exchanges.data && exchanges.data.length > 0 ? exchanges.data.map(function (exchangeObject, i) {
                return i === 0 ? "".concat(exchangeObject.attributes.name) : ", ".concat(exchangeObject.attributes.name);
              }) : 'No Exchange Associated']
            })
          })
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./components/shared/DetailsWithPhoto.tsx
var DetailsWithPhoto = __webpack_require__(3270);
;// CONCATENATED MODULE: ./components/software/review.js





var Title = typography/* default.Title */.Z.Title;
function Review(_ref) {
  var software = _ref.software;
  var name = software.name,
      details = software.details,
      seoMeta = software.seo_meta,
      image = software.image;

  var _ref2 = seoMeta || {},
      title = _ref2.title;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      className: "title-wrapper",
      style: {
        width: '100%',
        marginTop: '32px'
      },
      children: title || "".concat(name, " Review: Features, Pricing")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      style: {
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '22px',
        marginTop: '32px',
        boxSizing: 'border-box'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DetailsWithPhoto/* default */.Z, {
        details: details,
        image: image
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/software/index.tsx










function SoftwareContent(_ref) {
  var _software$broker, _software$broker$data;

  var software = _ref.software;
  var articles = software.articles.data,
      softwareRelatedArticles = software.softwareRelatedArticles,
      relatedSoftwares = software.relatedSoftwares;
  var input = {
    software: software.id,
    article_type: 'faq'
  };
  var title = 'Related Discussions';
  var linkList = [];

  if (softwareRelatedArticles) {
    softwareRelatedArticles.map(function (article) {
      linkList.push({
        href: '/article/[slug]/',
        as: "/article/".concat(article.slug, "/"),
        linkText: " ".concat(article.title),
        textDescription: "".concat(article.short_description)
      });
      return linkList;
    });
  }

  var relatedSoftwaresLinkList = [];
  var listTitle = 'Similar Software';

  if (relatedSoftwares) {
    relatedSoftwares.map(function (related_Software) {
      relatedSoftwaresLinkList.push({
        href: '/software/[slug]/',
        as: "/software/".concat(related_Software.slug, "/"),
        linkText: " ".concat(related_Software.name)
      });
      return relatedSoftwaresLinkList;
    });
  }

  var broker = (_software$broker = software.broker) === null || _software$broker === void 0 ? void 0 : (_software$broker$data = _software$broker.data) === null || _software$broker$data === void 0 ? void 0 : _software$broker$data.attributes;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionHead, {
        software: software
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Review, {
        software: software
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddFaq/* default */.Z, {
        input: input
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BrokerQuickLinks/* default */.Z, {
        broker: broker,
        RenderReview: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
        title: title,
        linkList: linkList
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
        title: listTitle,
        linkList: relatedSoftwaresLinkList
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleList/* default */.Z, {
        articles: articles,
        type: "softwares"
      })
    })]
  });
}
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/software/[slug].tsx










var title = function title(name) {
  return "".concat(name, " Defination, meaning, examples");
};

var description = function description(name) {
  return "".concat(name, " meaning, examples");
};

var __N_SSP = true;
function Software(props) {
  var _image$file;

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;
  var pageData = props.data;
  var allBrokers = pageData.all_brokers.data,
      softwareRecord = pageData.selected_software,
      navCalculators = pageData.nav_calculators.data,
      allPages = pageData.all_pages.data;
  var software = softwareRecord.data[0].attributes;
  var name = software.name,
      seoMeta = software.seo_meta,
      articleData = software.articles.data,
      image = software.image;

  var _ref = seoMeta || {},
      recordTitle = _ref.title,
      recordDescription = _ref.description;

  var pageTitle = title(name);
  var pageDescription = description(name);
  var images = [];

  if (image !== null && image !== void 0 && (_image$file = image.file) !== null && _image$file !== void 0 && _image$file.data) {
    var _image$file$data$, _image$file$data$$att, _image$file$data$$att2, _image$file$data$2, _image$file$data$2$at;

    var availableImage = ((_image$file$data$ = image.file.data[0]) === null || _image$file$data$ === void 0 ? void 0 : (_image$file$data$$att = _image$file$data$.attributes) === null || _image$file$data$$att === void 0 ? void 0 : (_image$file$data$$att2 = _image$file$data$$att.formats) === null || _image$file$data$$att2 === void 0 ? void 0 : _image$file$data$$att2.large) || ((_image$file$data$2 = image.file.data[0]) === null || _image$file$data$2 === void 0 ? void 0 : (_image$file$data$2$at = _image$file$data$2.attributes) === null || _image$file$data$2$at === void 0 ? void 0 : _image$file$data$2$at.url);
    images = [availableImage];
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: recordTitle || pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: recordDescription || pageDescription
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      images: images,
      title: pageTitle,
      description: pageDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaqSchema/* FAQPageJsonLd */.M, {
      articleDataArr: articleData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SoftwareContent, {
      software: software
    })]
  });
}

/***/ }),

/***/ 55404:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software/[slug]",
      function () {
        return __webpack_require__(95501);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pickAttrs; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);

/* eslint-enable max-len */
var ariaPrefix = 'aria-';
var dataPrefix = 'data-';
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if (
    // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) ||
    // Data
    mergedConfig.data && match(key, dataPrefix) ||
    // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,2769,6873,3679,6568,5045,5239,1096,8182,3492,3337,9774,2888,179], function() { return __webpack_exec__(55404); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);